import { useState, useCallback, useMemo } from "react";
import DictionaryInput from "./DictionaryInput";
import DictionaryResult from "./DictionaryResult";
import { DICTIONARY_GROUPS, DictionaryAI } from "../../lib/dictionaryApi";

export default function DictionaryPage() {
  
  // 한국어 전용 초기 상태
  const groups = useMemo(() => DICTIONARY_GROUPS(), []);
  const [selected, setSelected] = useState(() => {
    const init = {};
    groups.forEach((g) => (init[g.key] = new Set()));
    return init;
  });

  const [version, setVersion] = useState("2"); 
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [html, setHtml] = useState("");

  // 보조 기능: 식단
  const [mealPlanLoading, setMealPlanLoading] = useState(false);
  const [mealPlanError, setMealPlanError] = useState("");
  const [mealPlanHtml, setMealPlanHtml] = useState("");
  const [lastAnalysisText, setLastAnalysisText] = useState("");

  const onToggle = useCallback((groupKey, item) => {
    setSelected((prev) => {
      const next = { ...prev, [groupKey]: new Set(prev[groupKey]) };
      if (next[groupKey].has(item)) next[groupKey].delete(item);
      else next[groupKey].add(item);
      return next;
    });
  }, []);

  const flatSymptoms = useMemo(() => {
    const out = [];
    Object.values(selected).forEach((set) => set.forEach((v) => out.push(v)));
    return out;
  }, [selected]);

  const onSubmit = useCallback(async () => {
    setError("");
    setHtml("");
    setMealPlanError("");
    setMealPlanHtml("");
    setLastAnalysisText("");

    if (flatSymptoms.length === 0) {
      alert("불편한 증상을 하나 이상 선택해주세요.");
      return;
    }

    setLoading(true);
    try {
      const { answer, html } = await DictionaryAI.analyze({
        symptoms: flatSymptoms,
        version,
      });
      setHtml(html);
      setLastAnalysisText(answer);
    } catch (e) {
      setError(e?.message || "분석 실패");
    } finally {
      setLoading(false);
    }
  }, [flatSymptoms, version]);

  const onMealPlan = useCallback(async () => {
    setMealPlanError("");
    setMealPlanHtml("");

    if (!lastAnalysisText) return;
    setMealPlanLoading(true);
    try {
      const { html } = await DictionaryAI.mealPlan({
        symptoms: flatSymptoms,
        analysis: lastAnalysisText,
      });
      setMealPlanHtml(html);
    } catch (e) {
      setMealPlanError(e?.message || "생성 실패");
    } finally {
      setMealPlanLoading(false);
    }
  }, [flatSymptoms, lastAnalysisText]);

  return (
    <section>
      <div id="content_title">
        <h2>증상 분석 & 맞춤 관리 팁</h2>
        <p>
          현재 겪고 있는 증상을 선택하시면, AI가 맞춤 조언을 생성해 드립니다.
        </p>
      </div>

      <div className="content">
        <div>
          <DictionaryInput
            selected={selected}
            onToggle={onToggle}
            version={version}
            onChangeVersion={setVersion}
            onSubmit={onSubmit}
            loading={loading}
          />
          <DictionaryResult
            html={html}
            error={error}
            loading={loading}
            mealPlanHtml={mealPlanHtml}
            onMealPlan={onMealPlan}
            mealPlanLoading={mealPlanLoading}
            mealPlanError={mealPlanError}
          />
        </div>
      </div>
    </section>
  );
}
